import React from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { styled, alpha } from "@mui/material/styles";
import { Box, InputBase } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    // vertical padding + font size from searchIcon
    padding: "0 10px 0 10px ",
    width: "250px",
    height: "35px",
    transition: theme.transitions.create("width"),
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "25px",
    color: "rgba(0, 0, 0, 0.6)",
    letterSpacing: "0.15px",
    [theme.breakpoints.up("sm")]: {
      "&:focus": {},
    },
  },
}));
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const HeaderDocs = ({
  classes,

  handleSearchInputChange,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  console.log(location.state, "location");
  return (
    <Box
      className={classes.docsAppBar}
      sx={{ position: "sticky", top: "64px", zIndex: "100" }}
    >
      <Box
        className={classes.docsAppBarArea}
        sx={{ padding: "0px 20px !important" }}
      >
        <Box className={classes.docsTitle}>
          <Box
            sx={{
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/docs/folders");
            }}
          >
            My Docs
          </Box>{" "}
          <ArrowForwardIosRoundedIcon
            sx={{
              color: "rgba(0, 0, 0, 0.54)",
              ml: "14px",
              fontSize: "16px",
            }}
          />{" "}
          {location?.state?.folderDetails ? (
            <Box
              sx={{
                "&:hover": { textDecoration: "underline" },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(
                  `/docs/folders/${location?.state?.folderDetails?.parent_id}`,
                  {
                    state: { name: location?.state?.name },
                  }
                );
              }}
            >
              {location?.state?.name}
            </Box>
          ) : (
            `${location?.state?.name}`
          )}
          {location?.state?.folderDetails ? (
            <ArrowForwardIosRoundedIcon
              sx={{
                color: "rgba(0, 0, 0, 0.54)",
                ml: "14px",
                fontSize: "16px",
              }}
            />
          ) : null}
          {location?.state?.folderDetails
            ? `${location?.state?.folderDetails?.name}`
            : null}
        </Box>
        <Box className={classes.docsAppBarRight}>
          <Search>
            <StyledInputBase
              placeholder="Search Documents"
              inputProps={{ "aria-label": "search" }}
              onChange={(e) => handleSearchInputChange(e)}
            />
          </Search>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styleSheet, { name: "HeaderDocsStyle" })(HeaderDocs);
